import React, { Component } from "react";

class ProductSliderV1 extends Component {
  render() {
    const publicUrl = process.env.PUBLIC_URL + "/";
    const { product } = this.props; // Receive the current product as prop

    if (!product || !product.sliderImg) {
      return null;
    }

    return (
      <div className="">
        <div className="container">
          <div className="row ltn__slide-one-active slick-arrow-1 slick-slide-dots-1">
            {product.sliderImg?.map((img, imgIndex) => (
              <div className="col-lg-12" key={imgIndex}>
                <div className="ltn__img-slide-item-4">
                  {/* <a
                    href={img.ImgUrl}
                    data-rel="lightcase:myCollection"
                  > */}
                    <img
                      src={img.ImgUrl}
                      alt={`${product.title} - Slide ${imgIndex + 1}`}
                      // style={{
                      //   width: "100%",
                      //   height: "500px",   
                      //   objectFit: "cover" 
                      // }}
                    />
                  {/* </a> */}
                </div>
              </div>
              
            ))}
       

          </div>
        </div>
      </div>
    );
  }
}

export default ProductSliderV1;